// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stripeForm_stripeContainer__ghqOe {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n}\n\n.stripeForm_stripe__3H0Q- {\n  background-color: var(--primary-dark);\n  padding: 0.5rem;\n  border-radius: 6px;\n  margin-bottom: 1rem;\n  color: white;\n}\n\n.stripeForm_resultMessage__2g6nG {\n  line-height: 22px;\n  font-size: 16px;\n}\n\n.stripeForm_resultMessage__2g6nG a {\n  color: var(--lemon);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.stripeForm_cardError__2p720 {\n  color: var(--red);\n}\n\n.stripeForm_hidden__3aE3w {\n  display: none;\n}", ""]);
// Exports
exports.locals = {
	"stripeContainer": "stripeForm_stripeContainer__ghqOe",
	"stripe": "stripeForm_stripe__3H0Q-",
	"resultMessage": "stripeForm_resultMessage__2g6nG",
	"cardError": "stripeForm_cardError__2p720",
	"hidden": "stripeForm_hidden__3aE3w"
};
module.exports = exports;
